import { apiService } from '../_services'

export const exchangeService = {
  addExchange,
  getExchange,
  getExchangeById,
  deleteExchange,
  getExchangeByPage,
  updateExchange
}

function addExchange(exchange){
  return apiService.fetchAuthPost('exchange',exchange)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function getExchange(){
  return apiService.fetchAuthGet('exchange')
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function getExchangeByPage(start, pageSize, search) {
  return apiService.fetchAuthGet('exchange/page?start=' + start + '&pageSize=' + pageSize + '&search=' + search)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function deleteExchange(id,userId){
  return apiService.fetchAuthPut('exchange/delete/'+id+'/'+userId,{})
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function getExchangeById(id) {
  return apiService.fetchAuthGet('exchange/' + id)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function updateExchange(exchange, id) {
  return apiService.fetchAuthPut('exchange/' + id, exchange)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

